// custom components
import React, { useEffect, useState } from 'react';
import { ContentContainer } from 'components';
// import data from '../../utils/JSON/results.json';
import './dashboardCard.css';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useUserContext } from 'UserProvider';
import axios from '../../services/local/api';

const Dashboard = () => {
  const [, setLoading] = useState(false);
  const [prev, setPrev] = useState([]);
  const { userContext } = useUserContext();

  useEffect(() => {
    setLoading(true);

    const fetch = async () => {
      const userId = userContext?.userData?.id || localStorage.getItem('userId');
      const userName = userContext?.userData?.fullname || localStorage.getItem('username');
      const userEmail = userContext?.userData?.email || localStorage.getItem('userEmail');
      const res1 = await axios({
        url: '/api/results',
        method: 'POST',
        data: {
          email: userEmail,
          name: userName,
          UserId: userId
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });

      setPrev(
        res1?.data?.data?.past_result.sort((a, b) => {
          return new Date(b.examtime) - new Date(a.examtime);
        })
      );
    };

    fetch();
    setLoading(false);
  }, []);

  useEffect(() => {
    // console.log(process.env.REACT_APP_ENV);
    if (process.env.REACT_APP_ENV === 'production') {
      window.addEventListener('contextmenu', e => {
        e.preventDefault();
      });
      window.addEventListener(
        'keydown',
        function (e) {
          if (e.keyCode == 123) {
            e.preventDefault();
          }
          if (e.ctrlKey && e.shiftKey && e.keyCode == 73) {
            e.preventDefault();
          }
        },
        false
      );
    }
  }, []);
  return (
    <>
      <ContentContainer title="Dashboard">
        <div className="dashboard__container">
          <div className="dashboard__box">
            <h4>Previous Results</h4>
            {prev?.length > 0 &&
              prev.map((doc, i) => {
                if (i === 0) {
                  return (
                    <div style={{ fontSize: '17px !important' }} key={i}>
                      <Typography color="secondary">
                        Test Taken at : {new Date(doc.examtime).toDateString()}
                      </Typography>
                      <Typography color="secondary">TimeTaken : {doc.result.timetaken}</Typography>
                      <Typography color="secondary">Assessment Type : {doc.assessment}</Typography>
                      <Typography color="secondary">Exercise Name : {doc.result.exName}</Typography>
                      <Typography color="secondary">Words Per Minute : {doc.result.wpm}</Typography>
                      <Typography color="secondary">Errors : {doc.result.error}</Typography>
                      <Typography color="secondary">Word Count : {doc.result.wordcount}</Typography>
                    </div>
                  );
                }
              })}

            {prev?.length > 0 ? (
              <Link style={{ margin: 'auto' }} to="/result">
                <button style={{ margin: 'auto' }} type="submit" className="logoutButton">
                  Show More
                </button>
              </Link>
            ) : (
              <h6 style={{ align: 'center' }}>Please take a test for result.</h6>
            )}
          </div>
          {/* <div className="dashboard__box">
           <h2>Top Courses</h2>
           {courses.length > 0 ? (
             courses.map((course, i) => {
               if (i < 3)
                 return (
                   <div className="dashboard__top_courses" key={i}>
                     <p className="engrave__text">{course?.name}</p>
                   </div>
                 );
               return null;
             })
           ) : (
             <div className="loader-2">
               <div className="loader-2__dot"></div>
               <div className="loader-2__dot"></div>
               <div className="loader-2__dot"></div>
             </div>
           )}
           <button
             style={{ margin: 'auto' }}
             type="submit"
             variant="contained"
             fullwidth="true"
             className="button">
             Show More
           </button>
         </div> */}
        </div>
      </ContentContainer>
    </>
  );
};

export default Dashboard;
